import { DependentData } from '../DependentsPage';
import { Space, Typography } from 'antd';
import { MemberTypesEnum } from '../../claims/enum/MemberTypesEnum';
import { ManageDependent } from './ManageDependent';
import { InviteDependent } from './InviteDependent';

interface DependentRowProps {
  isSpouse: boolean;
  dependentData: DependentData;
}

export const DependentRow = ({ isSpouse, dependentData }: DependentRowProps): JSX.Element => {
  const dependantIsPrincipal = dependentData.memberType === MemberTypesEnum.PRINCIPAL;
  const { name } = dependentData;
  const isRegistered = dependantIsPrincipal || dependentData.registerStatus;

  return (
    <Space direction="vertical">
      <Typography.Text>{name}</Typography.Text>
      {/* Thuy's Note:  * if the current user is not PRINCIPAL           */}
      {/*                  => The spouse would be PRINCIPAL              */}
      {/*                  => not showing any action + register status   */}
      {/*               * not showing register status for child dependant*/}
      {!dependantIsPrincipal &&
        isSpouse &&
        (isRegistered ? (
          <ManageDependent dependentData={dependentData} />
        ) : (
          <InviteDependent dependentData={dependentData} />
        ))}
    </Space>
  );
};
